import GeneralLedgerDetail from "../../general-ledger/detail";

export default function SubsidiaryLedgerDetailS02c1() {
  return <GeneralLedgerDetail baseRoute="/templates/subsidiary-ledger" />;
}
